import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { grantAnalyticsConsent, trackPageView } from "../utils/analytics";
import "./CookieConsentBanner.css";

const STORAGE_KEY = "cookieConsent";

function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        setVisible(true);
      }
    } catch (err) {
      // If localStorage is unavailable (private mode, etc.), just show the banner.
      setVisible(true);
    }
  }, []);

  function handleChoice(choice) {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (err) {
      // Ignore storage errors; banner will simply reappear next visit.
    }

    if (choice === "accepted") {
      grantAnalyticsConsent();
      trackPageView(window.location.pathname);
    }

    setVisible(false);
  }

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-consent-banner" role="dialog" aria-live="polite">
      <div className="cookie-consent-text">
        We use cookies to improve your experience on TajneMysli. By continuing
        to use the site, you agree to our use of cookies. See our{" "}
        <Link to="/cookies">Cookie Policy</Link> for details.
      </div>

      <div className="cookie-consent-actions">
        <button
          type="button"
          className="cookie-consent-decline"
          onClick={() => handleChoice("declined")}
        >
          Decline
        </button>

        <button
          type="button"
          className="cookie-consent-accept"
          onClick={() => handleChoice("accepted")}
        >
          Accept
        </button>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
